exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.svg-logo[data-v-04bbb0be] {\n  float: left;\n  margin-right: 5px;\n}\n.new-feature-container[data-v-04bbb0be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 5px;\n  display: block;\n  width: auto;\n  padding: 0px 10px;\n}\n", ""]);

